import Rete from "rete";
import { PrintObjectControl } from "../../rete-controls/PrintObjectControl";
import AnyTypeSocket from "../../../Utils/CommonSockets";
 
export default class PrintObjectComponent extends Rete.Component {
    constructor(){
        super("Print Output"); // name
        this._categories = ["Output Nodes", "tryMe"];
    }

    builder(node) {
        let debugControl = new PrintObjectControl(this.editor,"display");
        let inp1 = new Rete.Input('in1','IN',AnyTypeSocket,true);
     
        return node
        .addInput(inp1)
        .addControl(debugControl);

    }

    worker(node, inputs, outputs) {
        let outputData = {};
        let index = 0;
        for(let connection in node.inputs.in1.connections){
            let nodeId = node.inputs.in1.connections[connection].node;
            let nodeOutput =  node.inputs.in1.connections[connection].output;
            let nodeName = this.editor.nodes.find(n => n.id == nodeId).name;
            let key =  `${nodeName}_${nodeId}_${nodeOutput}` ;
            outputData[key] = inputs['in1'][index++] 
        }
        
        this.editor.nodes
        .find(n => n.id == node.id)
        .controls.get("display")
        .setValue(outputData);

 
    }
}

//ReteComponentStore.add(new NumberDisplayComponent());